import { useEffect } from 'react';
import { trackViewContent } from '../utils/meta-pixel';

const CONTENT_SECTION_IDS = ['problems', 'features', 'testimonials', 'pricing'] as const;

/**
 * Dispara ViewContent do Meta Pixel quando cada seção de conteúdo entra em view (Intersection Observer).
 * Cada seção é disparada apenas uma vez.
 */
export const useViewContentSections = (): void => {
  useEffect(() => {
    const observed = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.id;
          if (!id || observed.has(id)) return;
          observed.add(id);
          trackViewContent(id);
        });
      },
      { rootMargin: '0px 0px -20% 0px', threshold: 0.1 }
    );

    CONTENT_SECTION_IDS.forEach((sectionId) => {
      const el = document.getElementById(sectionId);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);
};
